import { Children, isValidElement } from 'react';
import MessageActionsDropdown from './MessageActionsDropdown';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MessageActions = ({
  children,
  genericChannelId,
  collapsed
}) => {
  const currentlyCollapsedActions = collapsed ? children : Children.toArray(children).filter(child => {
    if ( /*#__PURE__*/isValidElement(child)) {
      return child === null || child === void 0 ? void 0 : child.props.collapsed;
    } else return null;
  });
  const currentlyUncollapsedActions = collapsed ? null : Children.toArray(children).filter(child => {
    if ( /*#__PURE__*/isValidElement(child)) {
      return !(child !== null && child !== void 0 && child.props.collapsed);
    } else return null;
  });
  return /*#__PURE__*/_jsxs("div", {
    className: 'display-inline justify-end',
    "data-test-id": "message-actions",
    children: [currentlyUncollapsedActions, /*#__PURE__*/_jsx(MessageActionsDropdown, {
      genericChannelId: genericChannelId,
      children: currentlyCollapsedActions
    })]
  });
};
MessageActions.displayName = 'MessageActions';
export default MessageActions;